module.exports = __webpack_public_path__ + "static/img/orderBac.280b9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/orderBac.png
// module id = C1YU
// module chunks = 1